export default "__VITE_ASSET__BvaWDGOP__"